import { authStorage } from './auth';

type Listener = () => void;
const listeners = new Set<Listener>();

let banned = false;

export function isUserBanned(): boolean {
  return banned;
}

export function subscribeBanned(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function notifyBanned(): void {
  listeners.forEach((listener) => listener());
}

export function markUserBanned(): void {
  if (banned) return;
  banned = true;
  authStorage.clear();
  notifyBanned();
}

export function clearBannedState(): void {
  banned = false;
}
